import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";
import $ from "jquery";
import Common from "../../src/pages/Quote/Common";
import Helper from "../../src/support/Helper";
import QuoteDetail from "./quote-detail";

let c = System.getParams();

class Quote {

    static ADD_QUOTE = Helper.getCartUrl() + '/api/quote/addItem';
    static ADD_QUOTE_IN_BULK = Helper.getCartUrl() + '/api/quote/addItems';
    static OPEN_QUOTE_LIST = Helper.getCartUrl() + '/api/quote/view';
    static SUBMITTED_QUOTE_EMAIL = Helper.getCartUrl() + '/api/quote/email';
    static CLEAR_ALL_QUOTE = Helper.getCartUrl() + '/api/quote/clear';
    static CLEAR_SINGLE_QUOTE = Helper.getCartUrl() + '/api/quote/deleteItem';
    static EDIT_QUOTE = Helper.getCartUrl() + '/api/quote/update';
    static QUOTE_MIN_PRICE_BY_SPEEDBOAT = Helper.getCartUrl() + '/api/quote/minprice';
    static SUBMIT_QUOTE = Helper.getCartUrl() + '/api/quote/submit';
    static QUOTE_SUBMITTED_LIST = QuoteDetail.QUOTE_SUBMITTED_LIST;
    static QUOTE_SUBMITTED_DETAIL_SHORT_INFORMATION = QuoteDetail.QUOTE_SUBMITTED_DETAIL_SHORT_INFORMATION;
    static QUOTE_SUBMITTED_DETAIL_LIST_BY_STATUS = QuoteDetail.QUOTE_SUBMITTED_DETAIL_LIST_BY_STATUS;
    static QUOTE_SUBMITTED_DETAIL_LIST_WITH_STATUS = QuoteDetail.QUOTE_SUBMITTED_DETAIL_LIST_WITH_STATUS;
    static QUOTE_SUBMITTED_DETAIL_LIST_FOR_DASHBOARD = QuoteDetail.QUOTE_SUBMITTED_DETAIL_LIST_FOR_DASHBOARD;
    static SUBMITTED_QUOTE_EXPORT = Helper.getCartUrl()+'/api/quote/export';
    static QUOTE_REASON_LIST = Helper.getCartUrl() + '/api/quote/quotereasons';
    static APPROVED_QUOTE_SEARCH = Helper.getCartUrl() + '/api/quote/quote/search';

    static getQuoteRouteURL() {
        return HCLDX.baseURL() + '/resources/my-avnet/quote';
    }

    static getQuoteHeaderDetailRouteURL() {
        c[Common.param_key] = Common.chain.QuoteHeaderDetail.param_value;
        return this.getURLBasedOnParamKey(c);
    }

    static getQuoteListingRouteURL() {
        c[Common.param_key] = Common.chain.QuoteListing.param_value;
        return this.getURLBasedOnParamKey(c);
    }
    static getSubmittedQuoteAbsoluteUrl() {
        let c_h = {} 
        c_h[Common.param_key] = Common.chain.QuoteListing.param_value;
        return this.getURLBasedOnParamKey(c_h);
    }

    static getQuoteDetailRouteURL(extra_c = {}) {
        c[Common.param_key] = Common.chain.QuoteDetail.param_value;
        return this.getURLBasedOnParamKey({
            ...c,
            ...extra_c
        });
    }

    static getQuoteCartRouteURL() {
        c[Common.param_key] = Common.chain.QuoteCart.param_value;
        return HCLDX.baseURL() + '/quote-cart';
    }

    static getQuoteCheckoutRouteURL() {
        c[Common.param_key] = Common.chain.QuoteCheckout.param_value;
        return HCLDX.baseURL() + '/quote-checkout';
    }

    static getQuoteCheckoutStatusRouteURL() {
        c[Common.param_key] = Common.chain.QuoteCheckoutStatus.param_value;
        return this.getURLBasedOnParamKey(c);
    }

    static getURLBasedOnParamKey(c) {
        return HCLDX.baseURL() + '/resources/my-avnet/quote?' + $.param(c);
    }
}

export default Quote;